// extracted by mini-css-extract-plugin
export default {"shareButton":"ZCbJhKKEFnQxyVZd5YBA-ShareButton-shareButton"};